import { render, staticRenderFns } from "./salesOrder.vue?vue&type=template&id=863ff5fa&scoped=true&"
import script from "./salesOrder.vue?vue&type=script&lang=js&"
export * from "./salesOrder.vue?vue&type=script&lang=js&"
import style0 from "./salesOrder.vue?vue&type=style&index=0&id=863ff5fa&lang=less&scoped=true&"
import style1 from "./salesOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863ff5fa",
  null
  
)

component.options.__file = "salesOrder.vue"
export default component.exports